<template>
  <div class="usia-slider-container">

    <Swiper
          ref="mySwiper"
          :options="swiperOptions"
          :slides-per-view="1"
          :pagination="{ clickable: true }"
          :scrollbar="{ draggable: true }"
        >

          <SwiperSlide 
                v-for="(row, index) in rows" 
                :key="index"
                :data-swiper-autoplay="row.duration + '000'">

              <div class="us-slide-card">
                <div class="us-slide-view" 
                  :style="'background: url('+row.file+');background-size: cover'"></div>
                <div class="us-slide-details" :style="'background:'+row.bg_color">
                    <div class="sub-title" v-html="row.title"></div>
                    <div class="sub-title-line" :style="'background:'+row.line_color"></div>
                    <div class="us-bg-title" v-html="row.subtitle"></div>
                    <div class="text" v-html="row.body"></div>
                    <router-link v-if="row.button" :to="row.redirect" class="us-btn">{{ row.button }}</router-link>
                    <div class="bg-colors">
                        <div class="bg-color-left" :style="'backgroundColor:'+row.box1_color"></div>
                        <div class="bg-color-right" :style="'backgroundColor:'+row.box2_color"></div>
                    </div>
                </div>
            </div>
          </SwiperSlide>

          <!-- If we need pagination -->
          
        
      </Swiper>

        <div class="swiper-pagination" slot="pagination"></div>

    <!-- <swiper ref="mySwiper" :options="swiperOptions">
        <swiper-slide :data-swiper-autoplay="duration + '000'">
            <div class="us-slide-card">
                <div class="us-slide-view" :style="{backgroundImage: `url(${require('../../assets/img/slider-1.png')})`}"></div>
                <div class="us-slide-details" :style="{backgroundColor: `${'#0020A5'}`}">
                    <div class="sub-title">Accreditation</div>
                    <div class="sub-title-line" :style="{backgroundColor: `${'#CB3026'}`}"></div>
                    <div class="us-bg-title" v-html="'Become  An Accredited <br /> Training Center'"></div>
                    <div class="text" v-html="'U.S Industrial Accreditation  (USIA) is One of the world’s <br /> premier professional studies and research institutions, (USIA)<br /> has driven new ways of thinking since our 1998 founding.'"></div>
                    <router-link to="/" class="us-btn">Explore</router-link>
                    <div class="bg-colors">
                        <div class="bg-color-left" :style="{backgroundColor: `${'#001157'}`}"></div>
                        <div class="bg-color-right" :style="{backgroundColor: `${'#001774'}`}"></div>
                    </div>
                </div>
            </div>
        </swiper-slide>
    </swiper>
    <div class="swiper-pagination" slot="pagination"></div> -->
  </div>
</template>

<style scoped>
.usia-slider-container {
    margin-bottom: 80px;
}
.us-slide-card {
    display: flex;
}
.us-slide-view {
    background-size: cover;
    background-position: center;
}
.us-slide-details {
    padding: 60px 60px 90px; 
    position: relative;
}
.bg-colors {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 70px;
    display: flex;
}
.bg-colors > div {
    height: 100%;
}
.bg-color-left {
    width: 70%;
}
.bg-color-right {
    width: 30%;
}
.us-slide-card > div {
    width: 50%;
}
.sub-title {
    font-weight: 500;
    color: #fff;
    font-size: 21px;
    margin-bottom: 8px;
}
.sub-title-line {
    width: 190px;
    height: 6px;
    margin-bottom: 8px;
}
.us-bg-title {
    font-size: 45px;
    color: #fff;
    font-weight: bold;
    line-height: 1;
    margin-bottom: 20px;
}
.text {
    color: #fff;
    font-size: 17px;
    line-height: 1.4;
    margin-bottom: 22px;
}
.us-btn {
    border: 1px solid #fff;
    color: #fff;
    padding: 2px 23px;
    display: inline-block;
    font-size: 18px;
}
.us-btn:hover {
    background: #fff;
    color: #000;
}
.us-btn:active {
    opacity: 0.6;
}
.swiper-pagination {
    padding: 30px 0;
    display: flex;
    justify-content: center;
    width: 100%;
}

/* Extra small devices (portrait phones, less than 576px) */
@media (max-width: 575.98px) {
    
}

@media (max-width: 767.98px) {
  .us-slide-card {
      display: block;
  }
  .us-slide-card > div {
      width: 100%;
  }
  .us-slide-details {
    padding: 30px 30px 90px;
  }
  .us-slide-view {
      height: 300px;
  }
}

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) and (max-width: 767.98px) {

}

/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) and (max-width: 991.98px) {

}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) and (max-width: 1199.98px) {

}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {

}
</style>

<script>
// Very Important npm install swiper@5.4.5 
import axios from 'axios';
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

export default {
  name: "Slider",
//   props: ['row'],
  components: {
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  
  data() {
    return {
      pgLoading: true,
      rows: [],
      duration: 4,
      swiperOptions: {
        loop: false,
        speed: 800,
        autoplay: {
            
          // delay: 4000, or data-swiper-autoplay="2000" in html
        },
        spaceBetween: 10,
        // slidesPerView: 3,
        navigation: {
            nextEl: '.swiperNext',
            prevEl: '.swiperPrev'
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          type: "bullets"
        },
      }
    };
  },
  created() {
      //
      this.fetchSlider();
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper
    }
  },
  methods: {
    prev() {
        this.$refs.mySwiper.$swiper.slidePrev();
    },
    next() {
        this.$refs.mySwiper.$swiper.slideNext();
    },
    fetchSlider() {
      axios
        .get(window.baseURL + "/sliders")
        .then((res) => {
          this.pgLoading = false;
          this.rows = res.data.rows;
        })
        .catch(() => {});
    },
  },
};
</script>